import { lazy, Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";
import type { RouteConfig } from "./types";

const AssetDetailsPage = lazy(() => import("../../MMS/asset-details"));

const AssetDetailsWithSuspense = () => (
	<Suspense
		fallback={
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}>
				<CircularProgress />
			</Box>
		}>
		<AssetDetailsPage />
	</Suspense>
);

export const assetDetailsRoutes: RouteConfig[] = [
	{
		path: "/asset-details",
		element: <AssetDetailsWithSuspense />,
	},
	{
		path: "/asset-details/:AssetIdParam",
		element: <AssetDetailsWithSuspense />,
	},
	{
		path: "/asset-details/:AssetIdParam/*",
		element: <AssetDetailsWithSuspense />,
	},
];
